import { render, staticRenderFns } from "./PageCompanyDetail.vue?vue&type=template&id=f345f986&scoped=true&"
import script from "./PageCompanyDetail.vue?vue&type=script&lang=js&"
export * from "./PageCompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageCompanyDetail.vue?vue&type=style&index=0&id=f345f986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f345f986",
  null
  
)

export default component.exports